import React from 'react';
import { Doctor } from 'types/doctor';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { doctorTableTemplate } from '../../template/doctorTableTemplate';

type DoctorListTableProps = {
  doctors: Doctor[];
};

const DoctorListTable: React.FC<DoctorListTableProps> = ({ doctors }) => {
  return (
    <DataGridList
      template={doctorTableTemplate}
      rows={doctors}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/doctors/${row.id}`)}
      fileName="medicos"
      sheetName="Médicos"
    />
  );
};

export default DoctorListTable;
